namespace $.$$ {

	/** Личная подпись собеседника: как владелец назвал его для себя. */
	export class $bog_gram_note extends $giper_baza_dict.with({
		Title: $giper_baza_atom_text,
	}) {}

}
